<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-panel-docs-preview></ui-panel-docs-preview></p>
<h1 id="description">Description</h1>
<p>Side panel</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-panel</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"Panel"</span>&gt;</span>
    Fill this up with yor custom html
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-panel</span>&gt;</span>
</code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
